import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/panel';
import { HeaderMobileModule } from '../header-mobile/header-mobile.module';

import {
  RecipeService,
  TarifService,
    LandingService
} from '../shared/services';

import { ConfidentialComponent, SafeHtmlPipe } from './info/confidential/confidential.component';
import { ContactsComponent } from './info/contacts/contacts.component';
import { EulaComponent } from './info/eula/eula.component';
import { BlogPagesComponent } from './info/blog-pages/blog-pages.component';
import { InfoComponent } from './info/info.component';
import { InstructionsComponent } from './info/instructions/instructions.component';
import { UserOfferComponent } from './info/user-offer/user-offer.component';
import { LandingComponent } from './landing.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { FooterComponent } from './footer/footer.component';
import { BlogComponent } from './info/blog/blog.component';

@NgModule({
  imports: [
    DialogModule,
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderMobileModule,
    BlockUIModule,
    ProgressSpinnerModule,
    PanelModule
  ],
  declarations: [LandingComponent, InfoComponent, EulaComponent, ConfidentialComponent, UserOfferComponent,
    ContactsComponent, InstructionsComponent, WelcomePageComponent, SafeHtmlPipe, FooterComponent,
    BlogComponent, BlogPagesComponent
  ],
  providers: [
    LandingService,
    TarifService,
    RecipeService
  ],
  exports: [LandingComponent]
})
export class LandingModule { }



// WEBPACK FOOTER //
// ./src/app/landing/landing.module.ts